import { upperFirst } from 'lodash';
import React from 'react';
import { TextCell } from 'v2/components/TextCell/TextCell';

interface CellProps {
  label: string;
}

export const OriginCell: React.FC<CellProps> = ({ label }) => <TextCell>{upperFirst(label)}</TextCell>;
